// Header.js
import React from 'react';


import 'antd/dist/antd.css';

class Header extends React.Component 
{
	constructor( props )
	{
		super(props);
		this.state = {}
		
	}

	componentDidMount() {
	}
	
	render()  {
			return (
				<div className='sg-footer sd-middle'>
					<div className='sg-footer-list sd-middle'>
						<div className='sg-list-font'>主办单位：国家市场监督管理总局登记注册局</div>
						
						<div className='sg-list-font' style={{marginLeft:'120px'}}>
							<span>建设单位：中国工商出版社</span>
							{/* <span>咨询电话：010-123456</span>
							<span className='sg-ml30'>申诉电话：010-123456</span> */}
						</div>
						<div className='sg-list-font' style={{marginLeft:'120px'}}>
							<span>系统推荐配置：推荐使用谷歌浏览器，分辨率1440*900以上最佳</span>
							{/* <span>咨询电话：010-123456</span>
							<span className='sg-ml30'>申诉电话：010-123456</span> */}
						</div>
					</div>
					{/* <div className='business-footer-list sg-ml50'>
						<div className='sg-list-font'>建设单位：中国工商出版社</div>
						<div className='sg-list-font'>&nbsp;</div>
					</div> */}
				</div>
			);

		
		
	}
}

export default Header

